var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { sortFolders } from "./helper";
var FolderAction;
(function (FolderAction) {
    FolderAction[FolderAction["NewFolderWithSharing"] = 0] = "NewFolderWithSharing";
    FolderAction[FolderAction["NewFolderWithoutSharing"] = 1] = "NewFolderWithoutSharing";
    FolderAction[FolderAction["ExistingFolderWithSharing"] = 2] = "ExistingFolderWithSharing";
    FolderAction[FolderAction["ExistingFolderWithoutSharing"] = 3] = "ExistingFolderWithoutSharing";
    FolderAction[FolderAction["SameFolderWithSharing"] = 4] = "SameFolderWithSharing";
    FolderAction[FolderAction["SameFolderWithoutSharing"] = 5] = "SameFolderWithoutSharing";
})(FolderAction || (FolderAction = {}));
var getUpdateSurveyActionFolder = function (newFolderName, request, collaborators, collaboratorsToRemove, selectedSurvey) {
    if (newFolderName && collaborators) {
        return FolderAction.NewFolderWithSharing;
    }
    else if (newFolderName && !collaborators) {
        return FolderAction.NewFolderWithoutSharing;
    }
    else if (!newFolderName &&
        (request === null || request === void 0 ? void 0 : request.parentId) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId) &&
        (collaborators || collaboratorsToRemove)) {
        return FolderAction.ExistingFolderWithSharing;
    }
    else if (!newFolderName &&
        (request === null || request === void 0 ? void 0 : request.parentId) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId) &&
        !collaborators &&
        !collaboratorsToRemove) {
        return FolderAction.ExistingFolderWithoutSharing;
    }
    else if (!newFolderName && (request === null || request === void 0 ? void 0 : request.parentId) === (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId) && collaborators) {
        return FolderAction.SameFolderWithSharing;
    }
    else {
        return FolderAction.SameFolderWithoutSharing;
    }
};
var updateSurveyFolderToNewFolderWithSharing = function (id, newFolderName, request, collaborators, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, removeSavedSearchFromFolder) { return __awaiter(void 0, void 0, void 0, function () {
    var contactIdsToAdd, subjectIdsToAdd, _a, formattedSubjectIds, folderRes, updateSurveyRes;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId)) return [3 /*break*/, 2];
                return [4 /*yield*/, removeSavedSearchFromFolder({
                        savedSearchId: id,
                        folderId: selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId,
                    })];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                contactIdsToAdd = collaborators === null || collaborators === void 0 ? void 0 : collaborators.map(function (c) { return c === null || c === void 0 ? void 0 : c.value; });
                if (!((contactIdsToAdd === null || contactIdsToAdd === void 0 ? void 0 : contactIdsToAdd.length) > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, getSubjectsFromContacts(contactIdsToAdd)];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 5];
            case 4:
                _a = [];
                _b.label = 5;
            case 5:
                subjectIdsToAdd = _a;
                formattedSubjectIds = subjectIdsToAdd === null || subjectIdsToAdd === void 0 ? void 0 : subjectIdsToAdd.map(function (s) { return ({ subjectId: s }); });
                return [4 /*yield*/, createSavedSearchFolder({
                        name: newFolderName,
                        collaborators: {
                            toAdd: formattedSubjectIds,
                        },
                    })];
            case 6:
                folderRes = _b.sent();
                return [4 /*yield*/, updateSurvey(id, __assign(__assign({}, request), { parentId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId, parentName: newFolderName }))];
            case 7:
                updateSurveyRes = _b.sent();
                if ((folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId) && (updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId)) {
                    setFolders(function (prev) {
                        var newFolder = {
                            name: newFolderName,
                            folderId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId,
                            isShared: true,
                            collaborators: collaborators,
                            sharedCount: collaborators === null || collaborators === void 0 ? void 0 : collaborators.length,
                        };
                        var sortedFolders = sortFolders(__spreadArray([newFolder], prev, true));
                        return sortedFolders;
                    });
                    setSurveys(function (prev) {
                        var newSurvey = __assign(__assign({}, request), { name: request === null || request === void 0 ? void 0 : request.name, id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId, modifiedDate: new Date().toISOString(), parentId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId });
                        var otherSurveys = prev === null || prev === void 0 ? void 0 : prev.filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.id); });
                        return __spreadArray([newSurvey], otherSurveys, true);
                    });
                    setSelectedSurvey({
                        id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId,
                        notes: request === null || request === void 0 ? void 0 : request.note,
                        name: request === null || request === void 0 ? void 0 : request.name,
                        folderId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId,
                        isAlertSet: request === null || request === void 0 ? void 0 : request.isAlertSet,
                        criteria: request === null || request === void 0 ? void 0 : request.criteria,
                    });
                    setSurveyContacts(collaborators);
                }
                return [2 /*return*/, updateSurveyRes];
        }
    });
}); };
var updateSurveyFolderToNewFolderWithoutSharing = function (id, newFolderName, request, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, selectedSurvey, removeSavedSearchFromFolder) { return __awaiter(void 0, void 0, void 0, function () {
    var folderRes, updateSurveyRes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId)) return [3 /*break*/, 2];
                return [4 /*yield*/, removeSavedSearchFromFolder({
                        savedSearchId: id,
                        folderId: selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId,
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, createSavedSearchFolder({
                    name: newFolderName,
                })];
            case 3:
                folderRes = _a.sent();
                return [4 /*yield*/, updateSurvey(id, __assign(__assign({}, request), { parentId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId, parentName: newFolderName }))];
            case 4:
                updateSurveyRes = _a.sent();
                if ((folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId) && (updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId)) {
                    setFolders(function (prev) {
                        var newFolder = {
                            name: newFolderName,
                            folderId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId,
                            isShared: false,
                        };
                        var sortedFolders = sortFolders(__spreadArray([newFolder], prev, true));
                        return sortedFolders;
                    });
                    setSurveys(function (prev) {
                        var newSurvey = __assign(__assign({}, request), { name: request === null || request === void 0 ? void 0 : request.name, id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId, modifiedDate: new Date().toISOString(), parentId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId });
                        var otherSurveys = prev === null || prev === void 0 ? void 0 : prev.filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.id); });
                        return __spreadArray([newSurvey], otherSurveys, true);
                    });
                    setSelectedSurvey({
                        id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId,
                        notes: request === null || request === void 0 ? void 0 : request.note,
                        name: request === null || request === void 0 ? void 0 : request.name,
                        folderId: folderRes === null || folderRes === void 0 ? void 0 : folderRes.folderId,
                        isAlertSet: request === null || request === void 0 ? void 0 : request.isAlertSet,
                        criteria: request === null || request === void 0 ? void 0 : request.criteria,
                    });
                }
                return [2 /*return*/, updateSurveyRes];
        }
    });
}); };
var updateSurveyFolderToExistingFolderWithSharing = function (id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateFolders, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, removeSavedSearchFromFolder) { return __awaiter(void 0, void 0, void 0, function () {
    var contactIdsToAdd, subjectIdsToAdd, _a, formattedSubjectIds, subjectIdsToRemove, _b, patchFolderReq, patchFolderRes, _c, updateSurveyRes;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!(selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId)) return [3 /*break*/, 2];
                return [4 /*yield*/, removeSavedSearchFromFolder({
                        savedSearchId: id,
                        folderId: selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId,
                    })];
            case 1:
                _d.sent();
                _d.label = 2;
            case 2:
                contactIdsToAdd = collaborators ? collaborators === null || collaborators === void 0 ? void 0 : collaborators.map(function (c) { return c === null || c === void 0 ? void 0 : c.value; }) : [];
                if (!((contactIdsToAdd === null || contactIdsToAdd === void 0 ? void 0 : contactIdsToAdd.length) > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, getSubjectsFromContacts(contactIdsToAdd)];
            case 3:
                _a = _d.sent();
                return [3 /*break*/, 5];
            case 4:
                _a = [];
                _d.label = 5;
            case 5:
                subjectIdsToAdd = _a;
                formattedSubjectIds = subjectIdsToAdd === null || subjectIdsToAdd === void 0 ? void 0 : subjectIdsToAdd.map(function (s) { return ({ subjectId: s }); });
                if (!((collaboratorsToRemove === null || collaboratorsToRemove === void 0 ? void 0 : collaboratorsToRemove.length) > 0)) return [3 /*break*/, 7];
                return [4 /*yield*/, getSubjectsFromContacts(collaboratorsToRemove)];
            case 6:
                _b = _d.sent();
                return [3 /*break*/, 8];
            case 7:
                _b = undefined;
                _d.label = 8;
            case 8:
                subjectIdsToRemove = _b;
                patchFolderReq = subjectIdsToRemove
                    ? {
                        collaborators: {
                            toAdd: formattedSubjectIds,
                            toRemove: subjectIdsToRemove,
                        },
                    }
                    : {
                        collaborators: {
                            toAdd: formattedSubjectIds,
                        },
                    };
                if (!(request === null || request === void 0 ? void 0 : request.parentId)) return [3 /*break*/, 10];
                return [4 /*yield*/, updateFolders(request === null || request === void 0 ? void 0 : request.parentId, patchFolderReq)];
            case 9:
                _c = _d.sent();
                return [3 /*break*/, 11];
            case 10:
                _c = undefined;
                _d.label = 11;
            case 11:
                patchFolderRes = _c;
                return [4 /*yield*/, updateSurvey(id, __assign(__assign({}, request), { parentId: patchFolderRes === null || patchFolderRes === void 0 ? void 0 : patchFolderRes.folderId }))];
            case 12:
                updateSurveyRes = _d.sent();
                if ((patchFolderRes === null || patchFolderRes === void 0 ? void 0 : patchFolderRes.folderId) && (updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId)) {
                    setSurveys(function (prev) {
                        var newSurvey = __assign(__assign({}, request), { name: request === null || request === void 0 ? void 0 : request.name, id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId, modifiedDate: new Date().toISOString(), parentId: request === null || request === void 0 ? void 0 : request.parentId });
                        var otherSurveys = prev === null || prev === void 0 ? void 0 : prev.filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.id); });
                        return __spreadArray([newSurvey], otherSurveys, true);
                    });
                    setSelectedSurvey({
                        id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId,
                        notes: request === null || request === void 0 ? void 0 : request.note,
                        name: request === null || request === void 0 ? void 0 : request.name,
                        folderId: request === null || request === void 0 ? void 0 : request.parentId,
                        isAlertSet: request === null || request === void 0 ? void 0 : request.isAlertSet,
                        criteria: request === null || request === void 0 ? void 0 : request.criteria,
                    });
                    setSurveyContacts(collaborators);
                }
                return [2 /*return*/, updateSurveyRes];
        }
    });
}); };
var updateSurveyFolderToExistingFolderWithoutSharing = function (id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey, removeSavedSearchFromFolder) { return __awaiter(void 0, void 0, void 0, function () {
    var updateSurveyRes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId)) return [3 /*break*/, 2];
                return [4 /*yield*/, removeSavedSearchFromFolder({
                        savedSearchId: id,
                        folderId: selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.folderId,
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, updateSurvey(id, request)];
            case 3:
                updateSurveyRes = _a.sent();
                if (updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId) {
                    setSurveys(function (prev) {
                        var newSurvey = __assign(__assign({}, request), { name: request === null || request === void 0 ? void 0 : request.name, id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId, modifiedDate: new Date().toISOString() });
                        var otherSurveys = prev === null || prev === void 0 ? void 0 : prev.filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.id); });
                        return __spreadArray([newSurvey], otherSurveys, true);
                    });
                    setSelectedSurvey({
                        id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId,
                        notes: request === null || request === void 0 ? void 0 : request.note,
                        name: request === null || request === void 0 ? void 0 : request.name,
                        isAlertSet: request === null || request === void 0 ? void 0 : request.isAlertSet,
                        folderId: request === null || request === void 0 ? void 0 : request.parentId,
                        criteria: request === null || request === void 0 ? void 0 : request.criteria,
                    });
                }
                return [2 /*return*/, updateSurveyRes];
        }
    });
}); };
var updateSurveySameFolderWithSharing = function (id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, updateFolders) { return __awaiter(void 0, void 0, void 0, function () {
    var contactIdsToAdd, subjectIdsToAdd, _a, formattedSubjectIds, subjectIdsToRemove, _b, patchFolderReq, patchFolderRes, _c, updateSurveyRes;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                contactIdsToAdd = collaborators ? collaborators === null || collaborators === void 0 ? void 0 : collaborators.map(function (c) { return c === null || c === void 0 ? void 0 : c.value; }) : [];
                if (!((contactIdsToAdd === null || contactIdsToAdd === void 0 ? void 0 : contactIdsToAdd.length) > 0)) return [3 /*break*/, 2];
                return [4 /*yield*/, getSubjectsFromContacts(contactIdsToAdd)];
            case 1:
                _a = _d.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = [];
                _d.label = 3;
            case 3:
                subjectIdsToAdd = _a;
                formattedSubjectIds = subjectIdsToAdd === null || subjectIdsToAdd === void 0 ? void 0 : subjectIdsToAdd.map(function (s) { return ({ subjectId: s }); });
                if (!((collaboratorsToRemove === null || collaboratorsToRemove === void 0 ? void 0 : collaboratorsToRemove.length) > 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, getSubjectsFromContacts(collaboratorsToRemove)];
            case 4:
                _b = _d.sent();
                return [3 /*break*/, 6];
            case 5:
                _b = undefined;
                _d.label = 6;
            case 6:
                subjectIdsToRemove = _b;
                patchFolderReq = subjectIdsToRemove
                    ? {
                        collaborators: {
                            toAdd: formattedSubjectIds,
                            toRemove: subjectIdsToRemove,
                        },
                    }
                    : {
                        collaborators: {
                            toAdd: formattedSubjectIds,
                        },
                    };
                if (!(request === null || request === void 0 ? void 0 : request.parentId)) return [3 /*break*/, 8];
                return [4 /*yield*/, updateFolders(request === null || request === void 0 ? void 0 : request.parentId, patchFolderReq)];
            case 7:
                _c = _d.sent();
                return [3 /*break*/, 9];
            case 8:
                _c = undefined;
                _d.label = 9;
            case 9:
                patchFolderRes = _c;
                return [4 /*yield*/, updateSurvey(id, __assign(__assign({}, request), { parentId: patchFolderRes === null || patchFolderRes === void 0 ? void 0 : patchFolderRes.folderId }))];
            case 10:
                updateSurveyRes = _d.sent();
                if ((updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId) && (patchFolderRes === null || patchFolderRes === void 0 ? void 0 : patchFolderRes.folderId)) {
                    setSurveys(function (prev) {
                        var newSurvey = __assign(__assign({}, request), { name: request === null || request === void 0 ? void 0 : request.name, id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId, modifiedDate: new Date().toISOString() });
                        var otherSurveys = prev === null || prev === void 0 ? void 0 : prev.filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.id); });
                        return __spreadArray([newSurvey], otherSurveys, true);
                    });
                    setSelectedSurvey({
                        id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId,
                        notes: request === null || request === void 0 ? void 0 : request.note,
                        name: request === null || request === void 0 ? void 0 : request.name,
                        isAlertSet: request === null || request === void 0 ? void 0 : request.isAlertSet,
                        criteria: request === null || request === void 0 ? void 0 : request.criteria,
                    });
                    setSurveyContacts(collaborators);
                }
                return [2 /*return*/, updateSurveyRes];
        }
    });
}); };
var updateSurveySameFolderWithoutSharing = function (id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey) { return __awaiter(void 0, void 0, void 0, function () {
    var updateSurveyRes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, updateSurvey(id, request)];
            case 1:
                updateSurveyRes = _a.sent();
                if (updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId) {
                    setSurveys(function (prev) {
                        var newSurvey = __assign(__assign({}, request), { name: request === null || request === void 0 ? void 0 : request.name, id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId, modifiedDate: new Date().toISOString() });
                        var otherSurveys = prev === null || prev === void 0 ? void 0 : prev.filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id) !== (selectedSurvey === null || selectedSurvey === void 0 ? void 0 : selectedSurvey.id); });
                        return __spreadArray([newSurvey], otherSurveys, true);
                    });
                    setSelectedSurvey({
                        id: updateSurveyRes === null || updateSurveyRes === void 0 ? void 0 : updateSurveyRes.savedSearchId,
                        notes: request === null || request === void 0 ? void 0 : request.note,
                        name: request === null || request === void 0 ? void 0 : request.name,
                        isAlertSet: request === null || request === void 0 ? void 0 : request.isAlertSet,
                        criteria: request === null || request === void 0 ? void 0 : request.criteria,
                    });
                }
                return [2 /*return*/, updateSurveyRes];
        }
    });
}); };
export { FolderAction, getUpdateSurveyActionFolder, updateSurveyFolderToNewFolderWithSharing, updateSurveyFolderToNewFolderWithoutSharing, updateSurveyFolderToExistingFolderWithSharing, updateSurveyFolderToExistingFolderWithoutSharing, updateSurveySameFolderWithSharing, updateSurveySameFolderWithoutSharing, };
//# sourceMappingURL=update-survey-helper-folder.js.map